import { fetchWithAuth } from './fetchWithAuth';

// 교육 목록 조회 - 지부코드, 분회코드, 연도
export const fetchEducationList = async (edu_year) => {
  const params = new URLSearchParams({ edu_year });
  return fetchWithAuth(`/education?${params}`);
};

// 교육 상세 조회 - 지부코드, 분회코드, 연도, 차수
export const fetchEducationDetail = async (edu_year, seq_no) => {
  return fetchWithAuth(`/education/${edu_year}/${seq_no}`);
};

// 교육 등록 - 지부코드, 분회코드, 연도, 차수
export const createEducation = async (form) => {
  return fetchWithAuth(`/education`, { method: 'POST', body: JSON.stringify(form) });
};

// 교육 수정 - 지부코드, 분회코드, 연도, 차수
export const updateEducation = async (edu_year, seq_no, form) => {
  return fetchWithAuth(`/education/${edu_year}/${seq_no}`, { method: 'PUT', body: JSON.stringify(form) });
};

// 교육 삭제 - 지부코드, 분회코드, 연도, 차수
export const deleteEducation = async (edu_year, seq_no) => {
  return fetchWithAuth(`/education/${edu_year}/${seq_no}`, { method: 'DELETE' });
};

// 세부일정 목록 조회
export const fetchEducationDetailList = async (edu_year, seq_no) => {
  return fetchWithAuth(`/education/${edu_year}/${seq_no}/detail`);
};

// 세부일정 등록
export const createEducationDetail = async (edu_year, seq_no, edu_dt, edu_place) => {
  return fetchWithAuth(`/education/${edu_year}/${seq_no}/detail`, {
    method: 'POST', body: JSON.stringify({ edu_dt, edu_place }),
  });
};

// 세부일정 삭제
export const deleteEducationDetail = async (edu_year, seq_no, edu_dt) => {
  return fetchWithAuth(`/education/${edu_year}/${seq_no}/detail/${edu_dt}`, { method: 'DELETE' });
};

// ===================== 교육신청 =====================

// 내 신청 목록 조회
export const fetchMyApply = async (edu_year, seq_no) => {
  return fetchWithAuth(`/education/${edu_year}/${seq_no}/apply/me`);
};

// 신청 목록 조회 (관리자용 - 특정 일자)
export const fetchApplyList = async (edu_year, seq_no, edu_dt) => {
  return fetchWithAuth(`/education/${edu_year}/${seq_no}/apply/${edu_dt}`);
};

// 교육신청 등록
export const createApply = async (edu_year, seq_no, edu_dt) => {
  return fetchWithAuth(`/education/${edu_year}/${seq_no}/apply/${edu_dt}`, { method: 'POST' });
};

// 교육신청 취소
export const deleteApply = async (edu_year, seq_no, edu_dt) => {
  return fetchWithAuth(`/education/${edu_year}/${seq_no}/apply/${edu_dt}`, { method: 'DELETE' });
};

// 신청자 목록 조회
export const fetchApplyMemberList = async (edu_year, seq_no, edu_dt) => {
  return fetchWithAuth(`/education/${edu_year}/${seq_no}/apply/${edu_dt}/members`);
};